$('footer').addClass('wp-footer');
$('main#root').addClass('wp-main');